const ContactButton = ({ onClick }) => {
    const handleClick = (e) => {
      console.log('[ContactButton] Button clicked!');
      if (onClick) {
        onClick(e);
      }
    };
  
    return (
      <button 
        type="button"
        className="group relative z-10 mt-10 cursor-pointer overflow-hidden"
        onClick={handleClick}
        aria-label="Contact us"
      >
        {/* Gradient background on hover */}
        <div 
          className="absolute inset-0 rounded-lg bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
          style={{ pointerEvents: 'none' }}
        />
        
        {/* Button content */}
        <div 
          className="relative rounded-lg border border-gray-700 bg-black px-8 py-4 transition-all duration-300 group-hover:border-transparent"
          style={{ pointerEvents: 'none' }}
        >
          <span className="relative z-10 text-sm font-semibold uppercase tracking-wider text-white">
            Contact Us
          </span>
        </div>
        
        {/* Optional: Add a cool glow effect on hover */}
        <div 
          className="absolute inset-0 rounded-lg bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-0 blur-xl transition-opacity duration-300 group-hover:opacity-30"
          style={{ pointerEvents: 'none' }}
        />
      </button>
    );
  };
  
  export default ContactButton;